const initialState = {
  listSessionData: [],
  sessiondataLoader: false,
};
const SessionDataActionReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LIST_SESSION_DATA":
      return { ...state, listSessionData: action.payload };
    case "SHOW_SESSION_DATA_LOADER":
      return { ...state, sessiondataLoader: true };
    case "HIDE_SESSION_DATA_LOADER":
      return { ...state, sessiondataLoader: false };
    default:
      return state;
  }
};

export default SessionDataActionReducer;
